
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stream-microinverter/specs",
      function () {
        return require("private-next-pages/stream-microinverter/specs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stream-microinverter/specs"])
      });
    }
  